import { format, formatDistanceToNow } from 'date-fns'

/**
 * Format date to readable string
 * @param {Date|string} date
 * @param {string} dateFormat
 * @returns {string}
 */
export const formatDate = (date, dateFormat = 'MMM d, yyyy') => {
  if (!date) return '-'
  return format(new Date(date), dateFormat)
}

/**
 * Format date relative to now (e.g., "2 hours ago")
 * @param {Date|string} date
 * @returns {string}
 */
export const formatDistanceDate = (date) => {
  if (!date) return '-'
  return formatDistanceToNow(new Date(date), { addSuffix: true })
}

/**
 * Format currency with AED
 * @param {number} amount
 * @returns {string}
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '-'
  return new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency: 'AED',
    minimumFractionDigits: 2,
  }).format(amount)
}

/**
 * Format percentage
 * @param {number} value
 * @param {number} decimals
 * @returns {string}
 */
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '-'
  return `${(value * 100).toFixed(decimals)}%`
}

/**
 * Format number with thousand separators
 * @param {number} value
 * @returns {string}
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined) return '-'
  return new Intl.NumberFormat('en-AE').format(value)
}

/**
 * Truncate string
 * @param {string} str
 * @param {number} length
 * @returns {string}
 */
export const truncate = (str, length = 50) => {
  if (!str) return '-'
  return str.length > length ? `${str.substring(0, length)}...` : str
}

/**
 * Format file size
 * @param {number} bytes
 * @returns {string}
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
}
